const LevelMap = {
  'heading-md': 'h1',
  'heading-sm': 'h1',
  'heading-sm-decorated': 'h1',
  'heading-xs': 'h2',
  'heading-xs-decorated': 'h2',
  'text-md-important': 'h3',
  'text-md-default': 'h4',
} as const
type LevelMap = typeof LevelMap
export default LevelMap
